import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { UserContext } from "../../context/userContext";
import useTailoring from "../../hooks/useTailoring";
// import NumberFormat from "react-number-format";

import PaymentModal from "../../Pages/PaymentModal";
import { ButtonContainer } from "../Shared/ButtonComponent";

const ItemDetails = (props) => {
  const { styleName, amount, description, duration, uniqueId } = props;
  const [paymentModal, setPaymentModal] = useState(false);

  const {handleGetCustomStylesCheckout} = useTailoring()

  const { userData } = useContext(UserContext);
  const user = userData?.user || {};
  const first_name = user?.first_name;
  const last_name = user?.last_name;
  const email = user?.email;

  const makeCustomTailoringOrder = (values) => {
    const payload = {
      values,
      id: uniqueId,
      redirect_url: "https://2mseamless-tailoring.vercel.app/success",
    };

    // setMakeOrderLoading(true);
    handleGetCustomStylesCheckout(payload)
      .then((res) => {
        const checkout_url = res?.data?.check_out?.responseBody?.checkoutUrl;
        window.localStorage.setItem("orderId", res?.data?.order_id?.InsertedID);
        window.location.href = checkout_url;
      })
      .catch((err) => {
        console.log(err);
        // toast.error(`'${err.response.data.error}'`, toastOptions);
      })
      .finally();
  };

  const formik = useFormik({
    initialValues: {
      delivery: "onsite",
      delivery_address: "",
      email,
      first_name,
      last_name,
      from_state: "abuja",
      lga: "",
      pick_up: "",
      quantity: 1,
      size: "",
      to_state: "",
      whatsapp_number: "",
    },
    onSubmit(values) {
      makeCustomTailoringOrder(values)
    },
  });

  return (
    <div className="item_details">
      <div>
        <p className="text-capitalize">{styleName}</p>
        <p>{description}</p>
        <p className="quan_p">
          <span>Quantity:</span>

          <span className="change_quantity cart-quantity">
            <span>
              <i className="fa-solid fa-minus"></i>
            </span>
            <span>{1}</span>
            <span>
              <i className="fa-solid fa-plus"></i>
            </span>
          </span>
        </p>
      </div>
      <div>
        <p>
          <span className="duration">Duration:</span>

          <span>{duration} days</span>
        </p>
        <p>
          <span className="outfit">Outfit Price:</span>

          <span>₦{amount}</span>
        </p>
        <p>
          <span className="delivery">Delivery:</span>
          <span></span>
        </p>
        <p>
          <span className="total">Total:</span>
          {}
          <span>₦{amount}</span>
        </p>
      </div>
      <div className="item_input">
        <p>WhatsApp Phone Number</p>
        <input type="number" />
      </div>

      <ButtonContainer onClick={() => formik.handleSubmit()}>
        Proceed to Pay ₦{amount}
      </ButtonContainer>

      <PaymentModal {...{ paymentModal, setPaymentModal }} />
    </div>
  );
};

export default ItemDetails;
